import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { roomTypePost } from "./roomTypeService";
import { successToast, errorToast } from "../../../components/toastmessage/toastmessage";


const useRoomTypeHook = (initialState) => {
    const navigate = useNavigate();
    const [roomTypeState, setRoomTypeState] = useState(initialState);


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setRoomTypeState((prevFormState) => ({
            ...prevFormState,
            [name]: value,
        }));

    }

    const handleRoomTypeSubmit = async (event) => {
        event.preventDefault();
        try {
            let payload = {
                ...roomTypeState,
                createdBy: JSON.parse(sessionStorage.getItem("tenantDetails"))[0]?.createdBy,
                tenantID: JSON.parse(sessionStorage.getItem("tenantDetails"))[0]?.tenantID,
                activeStatus: roomTypeState?.activeStatus === "true" ? true : false
            }
            let result = await roomTypePost(payload);
            if (result?.status === 200) {
                successToast("Successfully Inserted");
                setRoomTypeState(initialState)
            }
        } catch (e) {
            errorToast("Something went wrong")
        }


    }
    const handleGoBack = () => {
        navigate("/master/branch")
    }
    return {
        roomTypeState,
        setRoomTypeState,
        handleInputChange,
        handleRoomTypeSubmit,
        handleGoBack
    }


};


export default useRoomTypeHook;
